import script from "./FixedPromoMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedPromoMessage.vue?vue&type=script&setup=true&lang=js"

import "./FixedPromoMessage.vue?vue&type=style&index=0&id=9046044e&lang=scss"

const __exports__ = script;

export default __exports__